import { MarketingChannel } from "@redotech/redo-model/marketing";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const setCustomerSubscribed = {
  name: "setCustomerSubscribed" as const,
  input: z.object({
    customerId: zExt.objectId(),
    action: z.enum(["subscribe", "unsubscribe"]),
    channel: z.enum(MarketingChannel),
  }),
  output: z.object({}),
};
